import Notifications from "@/notifications/notifications";

/**
 * Muestra el resultado de cargar los productos de una cotizacion en el requerimiento
 * de traslado (al asignarla o al cerrar una cotizacion creada desde el requerimiento).
 *
 * resultado: { cotizacion, requerimiento, agregados, reemplazados, fallidos }
 * Retorna true si habia resultado que mostrar.
 */
export function mostrarResumenCargaCotizacion(resultado) {
  if (!resultado) {
    return false;
  }
  const agregados = resultado.agregados || [];
  const reemplazados = resultado.reemplazados || [];
  const fallidos = resultado.fallidos || [];
  const titulo = `Productos de la cotización #${resultado.cotizacion}`;
  const lineas = [
    `Requerimiento #${resultado.requerimiento}`,
    `Productos agregados: ${agregados.length}`,
    `Cantidad reemplazada: ${reemplazados.length}`,
  ];
  if (fallidos.length > 0) {
    lineas.push("");
    lineas.push(`No se pudieron agregar (${fallidos.length}):`);
    fallidos.forEach((item) => {
      lineas.push(`- ${item.sku} ${item.nombre} (${item.unidad_medida}): ${item.error}`);
    });
    Notifications.alert.warning(titulo, lineas.join("\n"));
  } else {
    Notifications.alert.success(titulo, lineas.join("\n"));
  }
  return true;
}
